import React from "react";
import { useTranslation } from "react-i18next";
import U2000ActionBtn from "../../../../u2000Core/components/buttons/U2000ActionBtn";
import U2000ResponsiveToolbar from "../../../../u2000Core/components/toolbar/U2000ResponsiveToolbar";
import { NS, U3143ROLES } from "../../../U3143";
import { FaPlus, FaRegFile, FaTrashAlt } from "react-icons/fa";
import { useU2000AuthContext } from "../../../../u2000Core/context/auth/U2000UseAuthContext";
import type { U2000FormStateHandlers } from "../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers";
import { U2000FormStateEnumState } from "../../../../u2000Core/reducer/formReducer/U2000FormState";

interface U3143FormStateHandlers extends U2000FormStateHandlers<any> {
  getData: () => any;
  getFormState: () => U2000FormStateEnumState;
  addNewDistrictCadastre: () => void;
  modifyDistrictCadastre: () => void;
  deleteDistrictCadastre: () => void;
}

interface U3143DistrictCadastreFormBtnsComponentProps {
  formStateHandlers: U3143FormStateHandlers;
}

export const U3143DistrictCadastreFormToolBar: React.FC<U3143DistrictCadastreFormBtnsComponentProps> = ({ formStateHandlers }) => {
  const formState = formStateHandlers.getFormState();

  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();

  const actions = [
    {
      key: "add",
      label: t("btnAdd", { ns: NS }),
      hasRole: hasRole(U3143ROLES.ADD),
      handleClick: () => {
        formStateHandlers.addNewDistrictCadastre();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: "modify",
      label: t("btnModify", { ns: NS }),
      hasRole: hasRole(U3143ROLES.EDIT),
      handleClick: () => {
        formStateHandlers.modifyDistrictCadastre();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: "delete",
      label: t("btnDelete", { ns: NS }),
      hasRole: hasRole(U3143ROLES.DELETE),
      handleClick: () => {
        formStateHandlers.deleteDistrictCadastre();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
